// Library Imports
import { Navigate, Route, Routes } from "react-router-dom";
import React, { useRef, Suspense, lazy } from "react";
import { PopupProvider } from "./Component/Login/PopupContext.jsx";
import FeaturePaymentCard from "./Component/FeaturePaymentCard/FeaturePaymentCard.jsx";
import Certificate from "./Component/Certificate/Certificate.jsx";
import InsightPage from "./Pages/InsightPage/InsightPage.jsx";
import Wishlist from "./Component/Wishlist/Wishlist.jsx";

import {
  Home,
  // BlogDetails,
  TermsAndConditionsPage,
  FaqPage,
  // Checkouts,
  PricingDetails,
  // LoginPage,
  SignUpPage,
  PurchaseCancellationPage,
  CommunityGuidelinesPage,
  MyCertificate,
  PersonalInformation,
  MyCousesPages,
  EbookTwo,
  MyWishlist,
  PageNotFoundPage,
  ContentRequiredPage,
  BlogEjsPage,
  PrivacyPolicyPage,
  ResetPasswordPage,
  SuccessMessagePage,
  FalioursMassagePage,
  NoSubscriptionPage,
  // BundlePage
  //Add to cart 
} from "./Pages";

const Checkouts = lazy(() => import("./Pages/Checkouts"));
const BlogDetails = lazy(() => import("./Pages/BlogDetails"));
const LoginPage = lazy(() => import("./Pages/LoginPage"));

//  Language Context Import
import {
  LanguageContext,
  LanguageProvider,
} from "./Component/LanguageContext/LanguageContext.jsx";
import BundlePage from "./Pages/BundlePage/BundlePage.jsx";
import RedeemDiscount from "./Component/RedeemDiscount/RedeemDiscount.jsx";

// Context and State Management Imports
import {
  AboutusPageProvider,
  CheckoutPaymentContextProvider,
  CommunityGuidelinesProvider,
  EbookPageContextProvider,
  HomePageProvider,
  LoginPageContextProvider,
  PrivacyPolicyProvider,
  PurchaseCancellationProvider,
  SingupPageContextProvider,
  PricingPageContextProvider,
  TermsConditionProvider,
} from "./store";

// Utility and Configuration Imports
import PaymentGateWayApi from "./Pages/PaymentGateWayApi.jsx";
import auth from "./Auth/Auth.js";
import "./App.css";
import { Navbar } from "./Component/index.js";
// const Navbar = React.lazy(() => import("./Component/index.js"));
const Footer = React.lazy(() => import("./Component/Footer/Footer.jsx"));
import Route2 from "./paths/Route2.jsx";
const userDetails = auth.getAuthData();
// const PrivateRoute = ({ children }) => {
//   return userDetails ? children : <Navigate to="/home/login/" />;
// };
const PrivateRoute = ({ children }) => {
  const isLoggedIn = auth.isAuthenticated(); // this checks live from localStorage
  return isLoggedIn ? children : <Navigate to="/home/login/" />;
};

import { useEffect, useState } from "react";
import ContentRequiredPage2 from "./Pages/ContentRequiredPage2/ContentRequiredPage2.jsx";
import Checkouts2 from "./Pages/Checkouts2/index.js";

import SuccessMessage2 from "./Component/SuccessMessage2/SuccessMessage2.jsx";
import TransationReciept from "./Component/TransationReciept/TransationReciept.jsx";
import SuccessMessage3 from "./Component/SuccessMessage3/index.js";
import ResetPasswordFormPage from "./Pages/ResetPasswordPage/ResetPasswordFormPage.jsx";
import LoginSuccessPage from "./Pages/LoginPage/LoginSuccessPage.jsx";
import AutoLoginForm from "./Component/Login/AutoLogin.jsx";
import { Cart, CartCheckout } from "./Pages/Cart/index";

// Add ErrorBoundary component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h2>Something went wrong.</h2>
          <p>Please check the console for more details.</p>
          <button onClick={() => window.location.reload()}>Reload Page</button>
        </div>
      );
    }
    return this.props.children;
  }
}

const App = () => {
  return (
    <ErrorBoundary>
      <LanguageProvider>
        <PopupProvider>
          <Navbar />
          <Routes>
            {/* Add root redirect */}
            <Route path="/" element={<Navigate to="/home/" replace />} />
            <Route path="home/R2/*" element={<Route2 />} />
            <Route path="home/faqs" element={<FaqPage />} />
            <Route path="home/cart" element={<Cart />} />
            <Route path="home/cart-checkout" element={<CartCheckout />} />
            <Route
              path="home/checkout/:paymentId"
              element={
                <Suspense fallback={<div>Loading Checkout...</div>}>
                  <CheckoutPaymentContextProvider>
                    <Checkouts />
                  </CheckoutPaymentContextProvider>
                </Suspense>
              }
            />
            <Route
              path="home/login"
              element={
                <Suspense fallback={<div>Authenticating...</div>}>
                  <LoginPageContextProvider>
                    <LoginPage />
                  </LoginPageContextProvider>
                </Suspense>
              }
            />
            <Route
              path="home/loginsuccess"
              element={
                <LoginPageContextProvider>
                  <LoginSuccessPage />
                </LoginPageContextProvider>
              }
            />
            <Route
              path="home/signUp"
              element={
                <SingupPageContextProvider>
                  <SignUpPage />
                </SingupPageContextProvider>
              }
            />
            <Route
              path="home/underdevelopment"
              element={<ContentRequiredPage />}
            />
            <Route
              path="home/"
              element={
                <HomePageProvider>
                  <Home />
                </HomePageProvider>
              }
            />
            <Route path="home/pagenotfound" element={<PageNotFoundPage />} />
            <Route
              path="home/contentrequired"
              element={<ContentRequiredPage />}
            />
            <Route
              path="home/contentrequired2"
              element={<ContentRequiredPage2 />}
            />
            <Route path="/home/resetform" element={<ResetPasswordFormPage />} />
            <Route path="home/reset" element={<ResetPasswordPage />} />
            <Route path="home/success" element={<SuccessMessagePage />} />
            <Route path="home/success2" element={<SuccessMessage2 />} />
            <Route path="home/success3" element={<SuccessMessage3 />} />
            <Route path="home/Mycertificate" element={<Certificate />} />
            <Route
              path="home/transaction"
              element={
                <PricingPageContextProvider>
                  <TransationReciept />
                </PricingPageContextProvider>
              }
            />
            <Route path="home/failuremessage" element={<FalioursMassagePage />} />
            <Route
              path="home/personalinformation"
              element={
                <PrivateRoute>
                  <PersonalInformation />
                </PrivateRoute>
              }
            />
            <Route path="home/paymentgateway" element={<PaymentGateWayApi />} />
            <Route path="home/mycourses" element={<MyCousesPages />} />
            <Route path="home/pricing" element={<PricingDetails />} />
            <Route path="home/mycertificate" element={<MyCertificate />} />
            <Route path="home/ebooktwo" element={<EbookTwo />} />
            <Route path="home/blogDetails/:id" element={<BlogEjsPage />} />
            <Route
              path="home/NotSubscribedyet"
              element={<NoSubscriptionPage />}
            />
            <Route path="home/bundle" element={<BundlePage />} />
            <Route
              path="home/terms&condition"
              element={
                <HomePageProvider>
                  <TermsConditionProvider>
                    <TermsAndConditionsPage />
                  </TermsConditionProvider>
                </HomePageProvider>
              }
            />
            <Route
              path="home/purchaseCancellation"
              element={
                <HomePageProvider>
                  <PurchaseCancellationProvider>
                    <PurchaseCancellationPage />
                  </PurchaseCancellationProvider>
                </HomePageProvider>
              }
            />
            <Route
              path="home/CommunityGuidelines"
              element={
                <HomePageProvider>
                  <CommunityGuidelinesProvider>
                    <CommunityGuidelinesPage />
                  </CommunityGuidelinesProvider>
                </HomePageProvider>
              }
            />
            <Route
              path="home/privacypolicy"
              element={
                <HomePageProvider>
                  <PrivacyPolicyProvider>
                    <PrivacyPolicyPage />
                  </PrivacyPolicyProvider>
                </HomePageProvider>
              }
            />
            <Route
              path="home/mywishlist"
              element={
                <HomePageProvider>
                  <EbookPageContextProvider>
                    <AboutusPageProvider>
                      <MyWishlist />
                    </AboutusPageProvider>
                  </EbookPageContextProvider>
                </HomePageProvider>
              }
            />
            <Route path="home/*" element={<PageNotFoundPage />} />
            <Route path="home/reedemfulldisocunt" element={<RedeemDiscount />} />
            <Route path="home/Dashboard" element={<AutoLoginForm />} />
            <Route path="home/insights/:id" element={<InsightPage />} />
            <Route path="home/wishlist" element={<Wishlist />} />
          </Routes>
          <Suspense fallback={<div>Loading Footer...</div>}>
            <Footer />
          </Suspense>
        </PopupProvider>
      </LanguageProvider>
    </ErrorBoundary>
  );
};

export default App;